import apiService from './apiService.js';

const resource = '/recruitment_depth_charts';

export default {
    getAddableRecruitmentDepthChartList(locationId) {
        return apiService.get(`${resource}/addable_people`,
            {
                params: {
                    location_id: locationId,
                },
            });
    },
    getRemovableRecruitmentDepthChartList(locationId) {
        return apiService.get(`${resource}/members`,
            {
                params: {
                    location_id: locationId,
                },
            });
    },
    addRecruitmentDepthChart(personId, recruitmentDepthChartColumnId, locationId) {
        return apiService.post(`${resource}`,
            {
                chart_member_id: personId,
                recruitment_depth_chart_column_id: recruitmentDepthChartColumnId,
                location_id: locationId
            });
    },
    transferRecruitmentDepthChart(chartMemberId, recruitmentDepthChartColumn, locationId) {
        return apiService.post(`${resource}/transfer`,
            {
                chart_member_id: chartMemberId,
                recruitment_depth_chart_column: recruitmentDepthChartColumn,
                location_id: locationId
            });
    },
    removeRecruitmentDepthChart(personId) {
        return apiService.delete(`${resource}/${personId}`);
    },
    getPersonsRecruitmentNotes(personId) {
        return apiService.get('/get-recruitment-notes',
            {
                params: {
                    person_id: personId,
                },
            });
    },
    storeRecruitmentNotes(personId, notes, declinedInvitationReasonIds, otherReasons, locationId) {
        return apiService.post('/recruitment-notes',
            {
                person_id: personId,
                notes,
                declined_invitation_reasons_ids: declinedInvitationReasonIds,
                other_reasons: otherReasons,
                location_id: locationId,
            });
    },
    getMemberLastUpdatedAt(personId) {
        return apiService.get(`${resource}/last-updated-at`,
            {
                params: {
                    person_id: personId,
                },
            });
    }
};
